
import { Component, Vue } from 'vue-property-decorator';

import Home from './views/Home.vue';
import { State } from './utils/decorators';

@Component({ components: { Home } })
export default class App extends Vue {
  @State() AODmode;
  @State() offset;
  @State() userAgent;

  get isPWA() {
    return window.matchMedia('(display-mode: fullscreen)').matches;
  }

}
